import { RouteObject } from 'react-router-dom'
import ErrorBug from 'components/errors/bugs'
import ProtectedRoute from 'pages/promissory/protectedRoute'
import IdentityVerification from './identityVerification'
import VideoCapture from './videoCapture'
import PhotoCapture from './photoCapture'
import { FormProvider } from './contexts'
import FundLayout from 'layout/fund/FundLayout'

export const AuthenticationUserRoutes: RouteObject[] = [
    {
        path: '',
        element: <ProtectedRoute />,
        errorElement: <ErrorBug />,
        children: [
            {
                path: '/authentication-user',
                element: (
                    <FormProvider>
                        <FundLayout helmet="احراز هویت" />
                    </FormProvider>
                ),
                errorElement: <ErrorBug />,
                children: [
                    {
                        index: false,
                        path: 'identity-verification',
                        element: <IdentityVerification />,
                    },
                    {
                        index: false,
                        path: 'photo-capture',
                        element: <PhotoCapture />,
                    },
                    {
                        index: false,
                        path: 'video-capture',
                        element: <VideoCapture />,
                    },
                ],
            },
        ],
    },
]
